export const DEFAULT_CLOSE_PRESENCE_TIMEOUT = 200;
